<div style="pointer-events: visible">
  No records found.
  @if (showClearFilters) {
    <span style="cursor:pointer; text-decoration: underline;" (click)="clearAllFilters()">Clear all filters</span>
  }
</div>
